export default "__VITE_ASSET__12ab2121__"